/**
 * Social Share Platform Definitions
 * Centralises platform metadata so ShareModal doesn't embed URLs/colours inline.
 * Add or remove platforms here — no changes needed in ShareModal.jsx.
 */

import {
  IconBrandFacebook,
  IconBrandX,
  IconBrandLinkedin,
  IconBrandWhatsapp,
  IconBrandTelegram,
} from "@tabler/icons-react";

/**
 * @typedef {Object} SocialPlatform
 * @property {string} key        - Unique identifier used as the handleExternalShare argument
 * @property {string} name       - Human-readable platform name (also used in aria-label)
 * @property {string} color      - Tailwind bg-* class for the share button
 * @property {React.ComponentType} Icon - Tabler icon component
 * @property {number} iconSize   - Icon size in px
 * @property {(url: string, title: string) => string} buildUrl - Produces the intent / share URL
 */

export const SOCIAL_SHARE_PLATFORMS = [
  {
    key: "facebook",
    name: "Facebook",
    color: "bg-[#1877F2]",
    Icon: IconBrandFacebook,
    iconSize: 24,
    buildUrl: (url, title) =>
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&quote=${encodeURIComponent(title)}`,
  },
  {
    key: "x",
    name: "X",
    color: "bg-black",
    Icon: IconBrandX,
    iconSize: 20,
    buildUrl: (url, title) =>
      `https://x.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`,
  },
  {
    key: "linkedin",
    name: "LinkedIn",
    color: "bg-[#0A66C2]",
    Icon: IconBrandLinkedin,
    iconSize: 22,
    buildUrl: (url) =>
      `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
  },
  {
    key: "whatsapp",
    name: "WhatsApp",
    color: "bg-[#25D366]",
    Icon: IconBrandWhatsapp,
    iconSize: 22,
    buildUrl: (url, title) =>
      `https://api.whatsapp.com/send?text=${encodeURIComponent(`${title} ${url}`)}`,
  },
  {
    key: "telegram",
    name: "Telegram",
    color: "bg-[#0088cc]",
    Icon: IconBrandTelegram,
    iconSize: 22,
    buildUrl: (url, title) =>
      `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`,
  },
];
